import { render } from "./DisplayColor.vue?vue&type=template&id=3ee47df4&scoped=true"
import script from "./DisplayColor.vue?vue&type=script&lang=js"
export * from "./DisplayColor.vue?vue&type=script&lang=js"

import "./DisplayColor.vue?vue&type=style&index=0&id=3ee47df4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ee47df4"]])

export default __exports__